import React from 'react'
import PropTypes from 'prop-types'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'
import { Button } from 'loyal-react'

const getButtonPrint = (onClick) => {
  return (
    <div className='col-12 justify-content-center align-self-center'>
      <Button
        id='print-order-button'
        className='btn btn-sm btn-cart btn-icon'
        text='Imprimir Pedido'
        iconName='icon_press'
        onClick={onClick}
      />
    </div>
  )
}
export default function AboutOrder ({ selectedDiscount, pointsName }) {
  const valuePointsLabel = `${selectedDiscount !== null ? selectedDiscount.points : 0} ${pointsName}`
  const valueCreditosLabel = `R$ ${numberToStrCurrency(selectedDiscount !== null ? selectedDiscount.credit : 0, 2)}`

  return (
    <div className='about-order-invoice-credit p-0 col-md-4 col-12 border border-color-ui-2 radius bg-white mt-4'>
      <div className='border-bottom border-color-ui-2 px-2 py-3'>
        <h2 className='h3'>
          Sobre o pedido
        </h2>
      </div>

      <div className='p-2'>
        <div className='p-2'>
          <p>Tipo de resgate: <strong className='txt-body-sm color-brand-4'>Crédito em fatura</strong></p>
          <p>Valor em pontos: <strong className='txt-body-sm color-brand-4'>{valuePointsLabel}</strong></p>
          <p>Valor em crédito: <strong className='txt-body-sm color-brand-4'>{valueCreditosLabel}</strong></p>
        </div>
        <div className='print-button row px-2 pt-2 d-print-none'>
          {
            getButtonPrint(window.print)
          }
        </div>
      </div>
    </div>
  )
}

AboutOrder.propTypes = {
  selectedDiscount: PropTypes.object,
  pointsName: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/features/InvoiceCredit/AboutOrder.js